import { intersectionBy } from 'lodash';
import { Iuser } from '../models';
import { securityFunctions } from '../constants/securityFunctions';

/**
 * Determines if a user has admin privileges by checking if they have at least one admin security function
 * @param user - The user object containing security functions
 * @returns boolean - true if user has admin privileges, false otherwise
 */
export const isAdmin = (user: Iuser): boolean => {
    const adminSecurityFunctions = [
        securityFunctions.ManageBrands.id,
        securityFunctions.ManageAllUsers.id,
        securityFunctions.ManageAlerts.id,
        securityFunctions.ManageFacilities.id,
        securityFunctions.ViewCustomers.id,
        securityFunctions.ManageLocations.id,
        securityFunctions.ManageJobs.id,
        securityFunctions.ManageJobComments.id,
        securityFunctions.ManageAllMeasurementPoints.id,
        securityFunctions.ManageCustomerWorkOrders.id,
        securityFunctions.SalesAdmin.id,
        securityFunctions.SalesInstallation.id,
        securityFunctions.SalesManager.id,
        securityFunctions.SalesParts.id,
        securityFunctions.SalesService.id,
        securityFunctions.ManageProducts.id,
        securityFunctions.ManageSuggestedParts.id,
        securityFunctions.ViewSuggestedParts.id,
        securityFunctions.ManageReports.id,
        securityFunctions.RunReports.id,
        securityFunctions.ManageCodes.id
    ];

    const intersection = intersectionBy(
        user.securityFunctions,
        adminSecurityFunctions
    );
    return intersection.length > 0;
};
